import React from 'react';
import { t } from 'zedevs-locales';

export const translatePrinter = (path) => {
  return function TranslatePrinter({ item, itemKey }) {
    return <span>{t(path.concat([item[itemKey]]))}</span>;
  };
};
